export function createPauseableTimeout(callback, duration) {
  let startMs = null
  let remain = duration
  let timerId = null
  let isPaused = false

  const runTimer = () => {
    startMs = Date.now()

    timerId = setTimeout(() => {
      timerId = null
      startMs = null

      callback()
    }, remain)
  }

  return {
    pause() {
      if (isPaused || timerId === null) {
        return
      }

      remain = Math.max(0, remain - (Date.now() - startMs))

      clearTimeout(timerId)

      timerId = null
      startMs = null
      isPaused = true
    },

    continue() {
      if (!isPaused) {
        return
      }

      isPaused = false

      runTimer()
    },

    start(startDuration = duration) {
      this.reset()

      remain = startDuration
      isPaused = false

      runTimer()
    },

    reset() {
      if (timerId !== null) {
        clearTimeout(timerId)
      }

      timerId = null
      startMs = null
      remain = duration
      isPaused = false
    },

    hasTimer() {
      return timerId !== null
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/shared/utils/timeout/index.js